import {put,takeLatest,call} from 'redux-saga/effects';
import * as ordersService from "../../../services/orderService";
import {
    GET_DELIVERED_ORDERS_OF_VENUE,
    GET_DELIVERED_ORDERS_OF_VENUE_SUCCESS,
    GET_DELIVERED_ORDERS_OF_VENUE_ERROR
}
    from "../../actions/order";
function* getDeliveredOrdersOfVenueSaga(action) {
    try {
        const data=yield call(ordersService.GetDeliveredOrdersOfVenue,action.payload)
        yield put({
            type: GET_DELIVERED_ORDERS_OF_VENUE_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_DELIVERED_ORDERS_OF_VENUE_ERROR,error: error.data
        });
    }
}

export function* getDeliveredOrdersOfVenueSagaWatcher() {
    yield takeLatest(GET_DELIVERED_ORDERS_OF_VENUE,getDeliveredOrdersOfVenueSaga);
}